<template>
  <div v-if="material && data" class="relative h-full pb-4 overflow-y-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('material.sequence')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            type="number"
            v-model="data.sequence"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('material.securityStock')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            type="number"
            v-model="data.securityStock"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('material.remarks')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.remarks"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('material.mwAccountGroup')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownMwAccountGroups"
            :selected-item="selectedMwAccountGroup"
            name="mwAccountGroup"
            flat
            :mode="mode"
            size="sm"
            show-error-as-tooltip
            clearable
            :error="
              validations?.mwAccountGroup.required.$invalid
                ? validations.mwAccountGroup.required.$message
                : ''
            "
            @update:selected="handleMwAccountGroupSelection" />
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useLookupsStore } from '@/stores/lookups';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseInput from '../common/BaseInput.vue';
import BaseSelectDropdown from '../common/BaseSelectDropdown.vue';
import { type Material } from '@/types/Materials';
import type { SelectDropdownItem } from '@/types/Base';
import { useI18n } from 'vue-i18n';
import type { Validation } from '@vuelidate/core';

defineProps<{
  material: Material | undefined;
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
  validations?: Validation;
}>();

const { t: $t } = useI18n({ useScope: 'global' });

const data = defineModel<Material>();

const { dropdownMwAccountGroups } = storeToRefs(useLookupsStore());

const selectedMwAccountGroup = ref<SelectDropdownItem | null>(null);

function handleMwAccountGroupSelection(item: SelectDropdownItem) {
  if (!data.value) return;
  selectedMwAccountGroup.value = item ? item : null;
  data.value.mwAccountGroupId = item ? (item.value as string) : '';
}

function initDropdowns() {
  if (data.value) {
    if (data.value.mwAccountGroupId) {
      const selectedValue = dropdownMwAccountGroups.value.find(
        (item) => item.value == data.value?.mwAccountGroupId
      );
      if (selectedValue) selectedMwAccountGroup.value = selectedValue;
    }
  }
}

watch(
  () => data.value,
  () => {
    initDropdowns();
  },
  { deep: true }
);

onMounted(() => {
  initDropdowns();
});
</script>
